import { IT } from "../language";

export const configMocked = {
  defaultLanguage: IT,
  pollingInterval: 1000 * 60 * 0.5,
};
